/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-danger */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useAPIError from '../../../hooks/useAPIError';
import { useAuthStore } from '../../../store/AuthContext';
import { useAppStore } from '../../../store/AppContext';
import clubMasterCard from '../../../assets/images/club-mastercard.png';
import TarjetaTemporalSolicitarTarjeta from '../commons/TarjetaTemporalSolicitarTarjeta';
import { TarjetaService } from '../../../services';
import ConsultasGestiones from '../commons/ConsultasGestiones';
import SolicitarTarjetaOro from '../commons/SolicitarTarjetaOro';
import { StorageHelper } from '../../../utils/StorageHelper';
import { BackMappings } from '../../../utils/BackMappings';
import useSessionChecking from '../../../hooks/useSessionChecking';
import { CryptoUtil } from '../../../utils/CryptoUtil';

const TitularTpecEroski: FC = () => {
  const [goOn, setGoOn] = useState<boolean>(false);
  StorageHelper.setOrigin(BackMappings.TARJETA);
  useSessionChecking(BackMappings.TARJETA, setGoOn, goOn);

  const { t } = useTranslation();
  const dataUser = useAuthStore();
  const dataApp = useAppStore();

  const { addError, addErrorBack } = useAPIError();
  const [load, setLoad] = useState<boolean>(true);
  const [cardNumberLong, setCardNumberLong] = useState<string>();
  const [firstCharge, setFirstCharge] = useState(true);

  const getCardNumber = () => {
    TarjetaService.getTarjeta()
      .then((response) => {
        if (response.data.error) {
          if (
            firstCharge &&
            response.data.errorCode !== BackMappings.GO_TO_RELOGIN
          ) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          setLoad(false);
          addErrorBack(response.data);
        } else {
          setCardNumberLong(
            CryptoUtil.decryptAes(response.data.pojo.cardNumberLong),
          );
        }
        setFirstCharge(false);
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };

  useEffect(() => {
    if (dataUser.user.token !== '') {
      getCardNumber();
      setLoad(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (dataUser.user.token !== '') {
      getCardNumber();
    }
  });

  if (goOn) {
    return (
      <>
        {(() => {
          if (load) {
            return (
              <>
                {' '}
                <section className="header-tarjetas tarjetas">
                  <div className="container">
                    <div className="header-tarjetas__content">
                      <h1 className="header-tarjetas__title">
                        {t('tarjetas.tarjeta-club-mastercard.title')}
                      </h1>
                      <div className="bloque-etiquetas">
                        <span className="etiqueta">
                          {t('tarjetas.tarjeta-club-mastercard.eroski-club')}
                        </span>{' '}
                        +{' '}
                        <span className="etiqueta">
                          {t('tarjetas.tarjeta-club-mastercard.credit-card')}
                        </span>
                      </div>
                      <p>
                        {t('tarjetas.tarjeta-club-mastercard.partner-number')}{' '}
                        <strong>{cardNumberLong}</strong>
                      </p>
                    </div>
                  </div>
                </section>
                <section className="o-section--giant__top u-padding-bottom-hero section--background">
                  <div className="container-inner">
                    <div className="grupo-tarjetas">
                      <div className="img-tarjeta">
                        <img
                          src={clubMasterCard}
                          alt="Tarjeta Eroski Club y tarejta mastercard"
                        />
                      </div>
                    </div>

                    <div className="tarjeta__content">
                      <h2 className="bloque-datos__title">
                        <span className="divider__square brand-color" />
                        <span className="u-margin-right">
                          {t('tarjetas.tarjeta-club-mastercard.eroski-club')}
                        </span>
                      </h2>
                      <TarjetaTemporalSolicitarTarjeta />

                      {(() => {
                        if (!StorageHelper.isEcommerceBot()) {
                          return (
                            <>
                              <div className="divider small" />
                              <h2 className="bloque-datos__title">
                                <span className="divider__square brand-color" />
                                <span className="u-margin-right">
                                  {t(
                                    'tarjetas.tarjeta-club-mastercard.credit-card',
                                  )}
                                </span>
                              </h2>
                              <ConsultasGestiones />
                            </>
                          );
                        }
                        return false;
                      })()}
                    </div>
                  </div>
                </section>
                {(() => {
                  if (
                    !dataUser.user.isGibraltar &&
                    !dataUser.user.isEmpresa &&
                    !dataUser.user.isImpagosOr3x12 &&
                    !StorageHelper.isEcommerceBot()
                  ) {
                    return (
                      <section className="o-section--superhero tarjetas">
                        <div className="container">
                          <h2 className="titulo-pagina u-text-brand u-text-center">
                            {t('tarjetas.tarjeta-club-mastercard.save-more')}
                          </h2>
                          <SolicitarTarjetaOro />
                        </div>
                      </section>
                    );
                  }
                  return false;
                })()}
              </>
            );
          }
          return false;
        })()}
      </>
    );
  }
  return <></>;
};

export default TitularTpecEroski;
